<template>
    <l-tooltip>
        <slot />
    </l-tooltip>
</template>

<script>
import { LTooltip } from "vue2-leaflet"

export default {
    components: { LTooltip },
}
</script>